<template>
  <GcBaseLayout
    :title="title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :baseView="baseView"
    :key="pageKey"
    :backButtonEnable="true"
    :backButtonFunction="backButtonFunction"
    :formsConfig="formsConfig"
    :tabs="[]"
    :selectedIndex="undefined"
    ref="gc-base-layout"
    class="supplier-credit"
  >
    <slot />
    <template #headerContent>
      <GcHeaderContentDynamic
        :title="screenName"
        :createModeIsEditMode="true"
        :baseView="baseView"
        :primaryLabel="
          baseView.mode === 'create'
            ? `Create ${screenName} for Supplier Invoice # ${baseView.id}`
            : `${screenName} # ${baseView.id}`
        "
        :secondaryLabel="secondaryLabel"
        v-if="loaded"
      />
    </template>
    <div v-if="loaded" class="css-v2 transaction-screen">
      <div class="gc-header-toolbar">
        <gc-form-header-toolbar
          :toolbar-options="getHeaderToolbar"
          :data-model="loaded ? model : {}"
          :itemSaveCallBack="saveTransaction"
          :backRoute="backButtonRoute"
          :setLoading="showLoading"
          ref="gc-form-header-toolbar"
          :baseView="baseView"
        ></gc-form-header-toolbar>
      </div>

      <div class="gc-header-form" v-show="!gridExpand">
        <div class="header-form">
          <div class="view-card responsive-paddings">
            <gc-form
              :formOptions="{
                gcLabelLocation: 'left',
              }"
              :formItems="getHeaderFormItems"
              :isNormal="true"
              :data-model="loaded ? model : {}"
              :formMode="baseView.mode"
              :fromFrom="'gc-header-form'"
              ref="gc-header-form"
              :checkValid="isValid"
              :validationGroup="'gc-header-form'"
              :scrollingEnabled="false"
              :formContentReady="onHeaderFormContentReady"
              :formHeight="100"
            ></gc-form>
          </div>
        </div>
      </div>

      <div class="gc-data-grid-so-v5 data-grid-details">
        <dx-data-grid
          :data-source="getLocalDataSource"
          :columns="getColumns"
          :height="getGridHeight"
          :column-chooser="{ enabled: false }"
          :ref="'dx-data-grid-comp'"
          key-expr="ID"
          :show-borders="true"
          :repaint-changes-only="true"
          :two-way-binding-enabled="false"
          :focusedRowEnabled="true"
          :selection="{ mode: 'multiple', showCheckBoxesMode: 'always' }"
          v-if="loaded"
          @selection-changed="onSelectionChanged"
          @editor-preparing="onEditorPreparing"
          @row-updated="onRowUpdated"
          @toolbar-preparing="onToolbarPreparing"
          @content-ready="onContentReady"
          @focused-cell-changed="onFocusedCellChanged"
          @editing-start="onEditingStart"
          @cell-prepared="onCellPrepared"
        >
          <DxEditing
            :allow-deleting="false"
            :allow-updating="baseView.mode !== 'review'"
            :mode="'cell'"
            :changes="changes"
          />
          <DxKeyboardNavigation
            :edit-on-key-press="true"
            :enter-key-action="'startEdit'"
            :enter-key-direction="'none'"
            :enabled="true"
          />
          <DxPager
            :showInfo="true"
            :showPageSizeSelector="false"
            :infoText="'({2} items)'"
            :visible="false"
            class="gc-pager"
            cssClass="gc-pages-2"
          />
          <template #Record="{ data }">
            <GcRecord
              :data="data"
              :primary="data.column['cellTemplateRecord']['primary']"
              :secondary="data.column['cellTemplateRecord']['secondary']"
            />
          </template>
          <template #Decimal="{ data }">
            <GcDecimal :dataValue="data" :format="data.column.format" />
          </template>
          <template #DecimalCell="{ data }">
            <GcDecimalCell :dataValue="data" :format="data.column.format" />
          </template>
          <template #Hyperlink="{ data }">
            <a @click.prevent="onHandleClick(data)">
              {{ data.data[data.column.dataField] }}
            </a>
          </template>

          <!-- Child Grid Details -->
          <DxMasterDetail :enabled="true" template="masterDetailTemplate" />
          <template #masterDetailTemplate="{ data: lineItem }">
            <dx-data-grid
              :data-source="lineItem.data.ChildDataSource"
              :columns="getChildGridColumns(lineItem)"
              :columnChooser="{
                enabled: false,
              }"
              :searchPanel="{
                visible: false,
              }"
              :pager="{ visible: false }"
              :ref="'master-details-' + lineItem.data.LineNo"
              :elementAttr="{ class: 'internal-grid' }"
              :focusedRowEnabled="true"
              :key-expr="'GoodsInLineNo'"
              :selection="{ mode: 'multiple', showCheckBoxesMode: 'always' }"
              @focused-cell-changed="onBatchFocusedCellChanged"
              @selection-changed="onBatchSelectionChanged"
              @row-updated="onBatchRowUpdated"
              @editor-preparing="onBatchEditorPreparing"
              @editing-start="onBatchEditingStart"
            >
              <DxEditing
                :allow-updating="true"
                :allow-deleting="false"
                mode="cell"
              />
              <DxKeyboardNavigation
                :edit-on-key-press="true"
                :enter-key-action="'startEdit'"
                :enter-key-direction="'none'"
                :enabled="true"
              />

              <template #Decimal="{ data }">
                <GcDecimal :dataValue="data" :format="data.column.format" />
              </template>
              <template #DecimalCell="{ data }">
                <GcDecimalCell :dataValue="data" :format="data.column.format" />
              </template>
            </dx-data-grid>
          </template>
        </dx-data-grid>
      </div>
      <GcFooter v-if="showFooter && loaded">
        <template #leftContent>
          <div
            class="gc-grid-footer-item left-content"
            v-for="item in footerLeftItems"
            :key="item.label"
          >
            <label class="gc-footer-label">{{ item.label }}</label>

            <label
              v-if="item.fieldType === 'custome-string'"
              class="gc-footer-value"
              >{{ item.value }}</label
            >
            <GcFooterItem
              :value="item.value"
              :format="item.format"
              :length="item.format === 'Decimal-16-4C' ? 8 : 4"
              v-else
            />
          </div>
        </template>
        <template #rightContent>
          <div
            class="gc-grid-footer-item"
            v-for="item in footerRightItems"
            :key="item.label"
          >
            <label class="gc-footer-label">{{ item.label }}</label>
            <GcFooterItem
              :value="item.value"
              :format="item.format"
              :length="item.format === 'Decimal-16-4C' ? 8 : 6"
            />
          </div>
        </template>
      </GcFooter>
    </div>
  </GcBaseLayout>
</template>
<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import { mapGetters } from "vuex";
import ArrayStore from "devextreme/data/array_store";
import { getGlobalField } from "@/_store/helpers";
import SettingsService from "@/_services/api/settings/graycorp/settings.service";
import { SupplierInvoiceDetailsService } from "@/_services/api/purchasing/supplier-invoice-details.service";
import { SupplierInvoiceService } from "@/_services/api/purchasing/supplier-invoice.service";
import ColumnWidth from "@/_helpers/data-grid/ColumnWidth";
import { backwardTabbing, forwardTabbing } from "@/_helpers/ui/keyboard";
import { SupplierService } from "@/_services/api/suppliers/supplier.service";
import { CompanyService } from "@/_services/api/accounts/company.service";
import { CompanyCurrencyService } from "@/_services/api/accounts/company-currency.service";
import { formatNumber } from "@/_helpers/formats/format";
import { DxMasterDetail } from "devextreme-vue/data-grid";
import DataGridMixin from "@/_mixins/data-grid.mixin";
import { GoodsInReviewService } from "@/_services/api/purchasing/goods-in-review.service";
import { SupplierCreditService } from "@/_services/api/purchasing/supplier-credit.service";
import { formatDate } from "devextreme/localization";

export default {
  mixins: [RouteMixin, FormMixin, DataGridMixin],
  components: { DxMasterDetail },
  data() {
    return {
      selectAllCheckBox: null,
      selectAllBatchCheckBox: [],
      screenName: "Supplier Credit",
      screenSettings: [],
      loaded: false,
      selectedRows: [],
      model: {
        Code: 0,
        Comment: "",
        DateIn: new Date(),
        Resupply: false,
        SupplierCode: "",
        DateChanged: undefined,
        SourceSupplierInvoiceCode: 0,
        PurchaseOrder: "",
        Invoice: "",
        CreditDate: new Date(),
        DueDate: "",
        CurrencyCode: "",
        ExchangeRate: "",
        FXAmount: 0,
        Rounding: 0,
        FXFreight: 0,
        GstAmount: 0,
        SupplierName: undefined,
        SupplierIsWetApplicable: "",
        Status: "",
        TermCalculation: "",
        Terms: 0,
        Total: 0,
      },
      changes: [],
      localDataSource: new ArrayStore({
        key: "LineNo",
        data: [],
      }),
      headerFormHeight: 0,
      isValid: false,
      showFooter: true,
      footerItems: [],
      toolBarFormInstance: undefined,
      headerFormInstance: undefined,
      supplierData: undefined,
      MinDateIn: undefined,
      CreditMaxDate: undefined,
      CreditMinDate: undefined,
      DueDateMin: new Date(),
      BaseCurrency: undefined,
      ForwardTabOnCreditDate: false,
      expandChildGrid: false,
      CollapseBtnContentReady: undefined,
      IsBatchAvailable: false,
      gridDataLoaded: false,
      BatchGridInstance: undefined,
      IsBatchLineClicked: false,
    };
  },
  async created() {
    this.loaded = false;
    this.showLoading(true);

    if (this.baseView.query.SUP_ID) {
      const id = decodeURI(this.baseView.query.SUP_ID);
      if (id) this.model.SupplierCode = JSON.parse(id);
    }

    return this.beforeInit().then(() => this.showLoading(false));
  },
  computed: {
    ...mapGetters({ gridExpand: "ui/getGridExpand" }),
    ...mapGetters({ gridHeight: "ui/getHeightForDataGrid" }),
    /**
     * Secondary Label
     * @returns {string|undefined}
     */
    secondaryLabel() {
      return this.baseView.mode === "create"
        ? this.model.SupplierName
        : undefined;
    },
    /**
     * Get Screen JSON
     * @returns {{title: string}}
     */
    getScreenJson() {
      return {
        title: this.screenName,
        endpoint: {
          primary:
            this.baseView.mode !== "create" ? "SupplierInvoice" : undefined,
        },
      };
    },
    /**
     * Header Toolbar
     * @returns {{notes: boolean, toolbarFormItems: [{dataField: string, cssClass: string, screenField: string, editorOptions: {dropDownOptions: {minWidth: number}, showClearButton: boolean, width: number}, label: {visible: boolean, text: string}}], save: boolean, screenName: string, toolbarAfterFormItems: [{dataField: string, editorOptions: {readOnly: boolean}, label: {text: string}, editorType: string}], status: boolean}}
     */
    getHeaderToolbar() {
      return {
        screenName: this.screenName,
        status: true,
        notes: false,
        save: true,
        // saveCallback: this.saveData,
        toolbarFormItems: [
          {
            // screenField: "Supplier",
            dataField: "SupplierName",
            cssClass: "toolbar-customer-label",
            editorOptions: {
              dropDownOptions: {
                minWidth: 300,
              },
              width: 300,
              showClearButton: true,
              readOnly: true,
              tabIndex: -1,
            },
            label: {
              text: "Supplier",
              visible: false,
            },
          },
        ],
        toolbarAfterFormItems: [
          {
            dataField: "Resupply",
            label: { text: "Re-Supply Order" },
            editorType: "dxSwitch",
            editorOptions: {
              readOnly: this.baseView.mode === "review",
            },
          },
        ],
      };
    },
    /**
     * Header Form Items
     * @returns {[{itemType: string, colCount: number, caption: string, items: [{itemType: string, caption: string, items: [{dataField: string, screenField: string, editorOptions: {readOnly: boolean}, label: {text: string}},{screenField: string}]},{itemType: string, caption: string, items: [{screenField: string, label: {text: string}},{screenField: string, label: {text: string}},{dataField: string, screenField: string}]},{itemType: string, caption: string, items: [{itemType: string, colCount: number, caption: string, items: [{screenField: string, editorOptions: {readOnly: boolean}, label: {text: string}},{screenField: string, editorOptions: {readOnly: boolean}}]},{screenField: string, label: {text: string}},{screenField: string, label: {text: string}}]}]}]}
     */
    getHeaderFormItems() {
      return [
        {
          itemType: "group",
          caption: "",
          colCount: 3,
          items: [
            {
              itemType: "group",
              caption: "",
              items: [
                {
                  screenField: "Invoice",
                  dataField: "PurchaseOrder",
                  label: {
                    text: "Purchase Order",
                  },
                  editorOptions: {
                    readOnly: true,
                    tabIndex: -1,
                  },
                },
                {
                  screenField: "DateIn",
                  editorOptions: {
                    min: this.CreditMinDate,
                    max: this.CreditMaxDate,
                    onValueChanged: async (e) => {
                      if (e.event) {
                        if (
                          e.value < this.CreditMinDate ||
                          e.value > this.CreditMaxDate
                        ) {
                          if (
                            new Date(this.MinDateIn) <
                            new Date(this.model.InvoiceDate)
                          ) {
                            // min is invoice
                            let alert;
                            if (e.value > this.CreditMaxDate) {
                              alert = await this.$alert(
                                `Date must be within the original Invoice Date ${formatDate(
                                  new Date(this.model.InvoiceDate),
                                  "dd MMM yyyy"
                                )} and ${formatDate(
                                  this.CreditMaxDate,
                                  "dd MMM yyyy"
                                )}.`,
                                "Validation Error"
                              );
                            } else
                              alert = await this.$alert(
                                `Date cannot be earlier than the original Invoice Date ${formatDate(
                                  new Date(this.model.InvoiceDate),
                                  "dd MMM yyyy"
                                )}. Please update the Date to be between ${formatDate(
                                  new Date(this.model.InvoiceDate),
                                  "dd MMM yyyy"
                                )} and ${formatDate(
                                  this.CreditMaxDate,
                                  "dd MMM yyyy"
                                )}.`,
                                "Validation Error"
                              );

                            if (alert) {
                              this.onDateInUpdate(e);
                            }
                          } else {
                            // min is AP min
                            let alert = await this.$alert(
                              `Date must be within the valid accounting period between ${formatDate(
                                this.MinDateIn,
                                "dd MMM yyyy"
                              )} and ${formatDate(
                                this.CreditMaxDate,
                                "dd MMM yyyy"
                              )}`,
                              "Validation Error"
                            );

                            if (alert) {
                              this.onDateInUpdate(e);
                            }
                          }
                        }
                      }
                    },
                    onFocusIn: (e) => {
                      e.event.target.select();
                    },
                    onKeyDown: (e) => {
                      if (backwardTabbing(e)) {
                        e.event.preventDefault();
                      }
                    },
                  },
                },
              ],
            },
            {
              itemType: "group",
              caption: "",
              items: [
                {
                  screenField: "Invoice",
                  label: {
                    text: "Invoice Number",
                  },
                },
                {
                  screenField: "InvoiceDate",
                  dataField: "CreditDate",
                  label: {
                    text: "Credit Date",
                  },
                  editorOptions: {
                    // min: this.CreditMinDate,
                    // max: this.CreditMaxDate,
                    onValueChanged: this.onCreditDateValueChanged,
                    onKeyDown: this.onCreditDateKeyDown,
                  },
                },
                {
                  screenField: "DueDate",
                  dataField: "DueDate",
                  editorOptions: {
                    min: this.DueDateMin,
                    onFocusIn: (e) => {
                      e.event.target.select();
                    },
                    onValueChanged: (e) => {
                      if (e.event) {
                        if (e.value < this.DueDateMin) {
                          e.component.beginUpdate();
                          e.component.option("value", e.previousValue);
                          e.component.endUpdate();
                        }
                      }
                    },
                  },
                },
              ],
            },
            {
              itemType: "group",
              caption: "",
              items: [
                {
                  itemType: "group",
                  caption: "",
                  colCount: 2,
                  items: [
                    {
                      screenField: "CurrencyCode",
                      label: {
                        text: "Currency",
                      },
                      editorOptions: {
                        readOnly: true,
                        tabIndex: -1,
                      },
                    },
                    {
                      screenField: "ExchangeRate",
                      editorOptions: {
                        readOnly: this.model.CurrencyCode === this.BaseCurrency,
                        tabIndex:
                          this.model.CurrencyCode === this.BaseCurrency
                            ? -1
                            : undefined,
                      },
                    },
                  ],
                },
                {
                  screenField: "FXAmount",
                  dataField: "Total",
                  label: {
                    text: "Total (" + this.getCurrencyCode + ")",
                  },
                  editorOptions: {
                    onValueChanged: (e) => {
                      if (!e.event) return;

                      const balance = this.footerItems.find(
                        (item) => item.dataField === "Balance"
                      ).value;

                      if (
                        (e.previousValue === 0 && e.value > 0) ||
                        (e.value > 0 && balance > 0)
                      )
                        e.value = e.value * -1;

                      const self = this;
                      self.model.Total = e.value;
                      self.updateFooter();
                    },
                  },
                },
                {
                  screenField: "Rounding",
                  dataField: "Rounding",
                  label: {
                    text: "Tax Adjustment (" + this.getCurrencyCode + ")",
                  },
                  editorOptions: {
                    onKeyDown: this.onTaxKeydown,
                    onValueChanged: (e) => {
                      const TaxAdjustment = this.footerItems.find(
                        (item) => item.dataField === "TaxAdjustment"
                      );
                      if (TaxAdjustment) {
                        TaxAdjustment.value = e.value;
                        this.updateFooter();
                      }
                    },
                  },
                },
              ],
            },
          ],
        },
      ];
    },
    /**
     * Back Button Route
     * @returns {*|string}
     */
    backButtonRoute() {
      if (this.baseView.query && this.baseView.query.from) {
        return this.baseView.query.from;
      } else return "/purchase-order";
    },
    /**
     * Get Currency Code
     * @returns {string}
     */
    getCurrencyCode() {
      return this.model.CurrencyCode;
    },
    /**
     * Data Grid
     * @returns {ArrayStore<*, any>}
     */
    getLocalDataSource() {
      return this.localDataSource;
    },
    /**
     * Column
     * @returns {*[]}
     */
    getColumns() {
      return this.parseColumnWithScreenFields([
        {
          caption: "",
          dataField: "",
          type: "detailExpand",
          fixed: true,
          fixedPosition: "left",
          visibleIndex: 0,
          width: 30,
          minWidth: 30,
        },
        {
          caption: "",
          dataField: "",
          type: "selection",
          fixed: true,
          fixedPosition: "left",
          visibleIndex: 1,
        },
        {
          dataField: "PurchaseOrderCode",
          caption: "Purchase Order",
          width: ColumnWidth.PurchaseOrderWrap.width,
          minWidth: ColumnWidth.PurchaseOrderWrap.minWidth,
          cellTemplate: "Hyperlink",
          dataType: "string",
          hyperlink: {
            url: `purchase-order/review/__ID__`,
            target: "_blank",
          },
          allowEditing: false,
          enabled: false,
        },
        {
          dataField: "GoodsInCode",
          caption: "Goods In",
          width: ColumnWidth.GoodsInCode.width,
          minWidth: ColumnWidth.GoodsInCode.minWidth,
          cellTemplate: "Hyperlink",
          dataType: "string",
          hyperlink: {
            url: `goods-in-review/review/__ID__`,
            target: "_blank",
          },
          allowEditing: false,
          enabled: false,
        },
        {
          screenField: "ProductItem",
          caption: "Product / Account",
          minWidth: 250,
          width: "auto",
          allowEditing: false,
          enabled: false,
          gridDataField: "ItemCode",
          allowSorting: true,
          sortOrder: "asc",
        },
        {
          dataField: "BranchCode",
          caption: "Branch",
          minWidth: ColumnWidth.BranchCode.width,
          width: ColumnWidth.BranchCode.minWidth,
          allowEditing: false,
        },
        {
          dataField: "DivisionCode",
          caption: "Division",
          minWidth: ColumnWidth.Division.width,
          width: ColumnWidth.Division.minWidth,
          allowEditing: false,
        },
        {
          dataField: "SupplierUM",
          caption: "UM",
          minWidth: ColumnWidth.Division.width,
          width: ColumnWidth.Division.minWidth,
          allowEditing: false,
        },
        {
          dataField: "TaxCode",
          caption: "Tax",
          minWidth: ColumnWidth.TaxCode.width,
          width: ColumnWidth.TaxCode.minWidth,
          allowEditing: false,
        },
        {
          dataField: "SupplierUMQuantity",
          caption: "Invoiced",
          width: ColumnWidth.Quantity.width,
          minWidth: ColumnWidth.Quantity.minWidth,
          cellTemplate: "Decimal",
          format: "##,###,###,###,##0.00",
          allowEditing: false,
        },
        {
          dataField: "SupplierOutstandingQuantity",
          caption: "Outstanding",
          minWidth: ColumnWidth.Quantity.width,
          width: ColumnWidth.Quantity.minWidth,
          cellTemplate: "Decimal",
          format: "##,###,###,###,##0.00",
          allowEditing: false,
        },
        {
          dataField: "SupplierAvailableQuantity",
          caption: "Available",
          minWidth: ColumnWidth.Quantity.width,
          width: ColumnWidth.Quantity.minWidth,
          cellTemplate: "Decimal",
          format: "##,###,###,###,##0.00",
          dataType: "number",
          allowEditing: false,
        },
        {
          dataField: "CreditQty",
          caption: "Credit",
          minWidth: ColumnWidth.Quantity.width,
          width: ColumnWidth.Quantity.minWidth,
          cellTemplate: "DecimalCell",
          format: "##,###,###,###,##0.00",
          dataType: "number",
          allowEditing: true,
          cssClass: "edit-cell-numberbox-field",
          editorOptions: {
            format: "##,###,###,###,##0.00",
            max: 999999999.0,
            maxLength: 9,
            step: 0,
            onFocusIn: (e) => {
              const input = e.element.querySelector("input");
              if (input.value < 0) {
                input.classList.add("gc-state-negative");
                e.element.classList.add("gc-state-negative");
              }
              e.event.target.select();
            },
            onInput: (e) => {
              const inputElement = e.event.target;
              if (inputElement.value.length > 14)
                inputElement.value = inputElement.value.slice(0, 14);
            },
            onKeyDown: this.onCreditQtyKeyDown,
          },
          setCellValue: this.onSetCreditCellValue,
        },
        {
          dataField: "FXPrice",
          caption: `Unit Price (${this.getCurrencyCode})`,
          minWidth: ColumnWidth.Price4DecimalPoints.width,
          width: ColumnWidth.Price4DecimalPoints.minWidth,
          cellTemplate: "Decimal",
          format: "$ ##,###,###,###,##0.0000;($ ##,###,###,###,##0.0000)",
          dataType: "number",
          allowEditing: false,
        },
        {
          dataField: "Amount",
          caption: `Ex Total (${this.getCurrencyCode})`,
          minWidth: ColumnWidth.Quantity.width,
          width: ColumnWidth.Quantity.minWidth,
          cellTemplate: "Decimal",
          format: "$ ##,###,###,###,##0.00;($ ##,###,###,###,##0.00)",
          dataType: "number",
          allowEditing: false,
        },
        {
          dataField: "FXTaxLineTotal",
          caption: `Tax (${this.getCurrencyCode})`,
          minWidth: ColumnWidth.Quantity.width,
          width: ColumnWidth.Quantity.minWidth,
          cellTemplate: "Decimal",
          format: "$ ##,###,###,###,##0.00;($ ##,###,###,###,##0.00)",
          dataType: "number",
          allowEditing: false,
        },
        {
          dataField: "FXIncTaxLineTotal",
          caption: `Inc Total (${this.getCurrencyCode})`,
          minWidth: ColumnWidth.Quantity.width,
          width: ColumnWidth.Quantity.minWidth,
          cellTemplate: "Decimal",
          format: "$ ##,###,###,###,##0.00;($ ##,###,###,###,##0.00)",
          dataType: "number",
          allowEditing: false,
        },
        {
          dataField: "Comments",
          caption: "Comments",
          cssClass: "edit-cell-textbox-field",
          minWidth: ColumnWidth.Comment.width,
          width: ColumnWidth.Comment.minWidth,
          allowEditing: this.baseView.mode !== "review",
          editorOptions: {
            onFocusIn: (e) => {
              e.event.target.select();
            },
            onKeyDown: this.onCommentsKeyDown,
          },
        },
      ]);
    },
    /**
     * Grid Height
     * @returns {number}
     */
    getGridHeight() {
      if (this.headerFormHeight)
        return (
          this.gridHeight - (this.gridExpand ? 6 : this.headerFormHeight) - 117
        );
      else return this.gridHeight - 117;
    },
    /**
     * Header Screen
     * @returns {{title: {secondary: {dataField: (string|undefined), text: undefined}, createModeIsEditMode: boolean, primary: {secondary: {dataField: undefined, text: undefined}, primary: {dataField: (string|undefined), text: string}}}}}
     */
    getHeaderScreenJson() {
      return {
        title: {
          createModeIsEditMode: true,
          primary: {
            primary: {
              dataField: this.baseView.mode !== "create" ? "Code" : undefined,
              text:
                this.baseView.mode !== "create"
                  ? `${this.screenName} #`
                  : `Create ${this.screenName}`,
            },
            secondary: {
              dataField: undefined,
              text: undefined,
            },
          },
          secondary: {
            dataField:
              this.baseView.mode !== "create" ? "SupplierName" : undefined,
            text: undefined,
          },
        },
      };
    },
    /**
     * Footer Left Item
     * @returns {(*|{[p: string]: *})[]}
     */
    footerLeftItems() {
      const leftItems = this.footerItems.filter((x) => x.location === "left");

      return leftItems
        .map((c) => {
          let globalField = { ...getGlobalField(c.screenField) };
          if (Object.keys(globalField).length === 0) return c;

          if (typeof c.value !== "undefined") globalField.value = c.value;
          if (typeof c.dataField !== "undefined")
            globalField.dataField = c.dataField;
          if (typeof c.label !== "undefined") globalField.label = c.label;
          if (typeof c.format !== "undefined") globalField.format = c.format;
          if (typeof c.fieldType !== "undefined")
            globalField.fieldType = c.fieldType;
          if (typeof c.length !== "undefined") globalField.length = c.length;
          if (globalField.type === "Decimal") {
            globalField.label = globalField.label.replace(
              "(Customer Currency)",
              `(${this.model.CurrencyCode})`
            );
          }
          if (globalField.type === "Decimal") {
            globalField.label = globalField.label.replace(
              "(Customer Currency)",
              `(${this.model.CurrencyCode})`
            );
          }
          if (globalField) return globalField;
          else return c;
        })
        .filter((x) => x != null);
    },
    /**
     * Footer Right Item
     * @returns {(*|{[p: string]: *})[]}
     */
    footerRightItems() {
      const rightItems = this.footerItems.filter(
        (x) =>
          x.location === "right" &&
          (x.hasOwnProperty("visible") ? x.visible : true)
      );

      return rightItems
        .map((c) => {
          let globalField = { ...getGlobalField(c.screenField) };

          if (Object.keys(globalField).length === 0) return c;

          if (typeof c.value !== "undefined") globalField.value = c.value;
          if (typeof c.dataField !== "undefined")
            globalField.dataField = c.dataField;
          if (typeof c.label !== "undefined") globalField.label = c.label;
          if (typeof c.format !== "undefined") globalField.format = c.format;

          if (globalField.type === "Decimal") {
            globalField.label = globalField.label.replace(
              "(Customer Currency)",
              `(${this.model.CurrencyCode})`
            );
          }

          if (globalField) return globalField;
          else return c;
        })
        .filter((x) => x != null);
    },
    /**
     * Footer Item
     * @returns {[{dataField: string, screenField: string, customCalc: (function(*, *): number), location: string, label: string, value: number},{dataField: string, screenField: string, location: string, value: number},{dataField: string, screenField: string, format: string, location: string, label: string, value: number},{dataField: string, screenField: string, format: string, location: string, label: string, value: number},{dataField: string, screenField: string, format: string, location: string, label: string, value: number}]}
     */
    getFooterItems() {
      return [
        {
          screenField: "SalesUMItemCount",
          dataField: "SupplierRequired",
          location: "left",
          label: "Line Count",
          value: 0,
          customCalc: (headerData, gridItems) => {
            let count = 0;
            gridItems.forEach((element) => {
              if (element.ItemCode) count++;
            });

            return count;
          },
        },
        {
          screenField: "SalesUMItemCount",
          dataField: "ItemCount",
          location: "left",
          value: 0,
        },
        {
          dataField: "FXLineTotal",
          screenField: "TaxableFXTotal",
          location: "right",
          value: 0,
          format: "Decimal-16-2C",
          label: `Sub Total (${this.model.CurrencyCode})`,
        },
        {
          screenField: "TaxFXTotal",
          dataField: "TaxFXTotal",
          location: "right",
          value: 0,
          format: "Decimal-16-2C",
          label: `Tax (${this.model.CurrencyCode})`,
        },
        {
          screenField: "FXTotal",
          dataField: "FXIncTaxLineTotal",
          location: "right",
          value: 0,
          format: "Decimal-16-2C",
          label: `Total (${this.model.CurrencyCode})`,
        },
        {
          screenField: "TaxAdjustment",
          dataField: "TaxAdjustment",
          location: "right",
          value: 0,
          format: "Decimal-16-2C",
          label: `Tax Adjustment (${this.model.CurrencyCode})`,
        },
        {
          screenField: "Balance",
          dataField: "Balance",
          location: "right",
          value: 0,
          format: "Decimal-16-2C",
          label: `Balance (${this.model.CurrencyCode})`,
        },
      ];
    },
    /**
     * Return Date Grid Instance
     *  @returns {object|undefined}
     */
    getDataGridInstance() {
      return this.$refs["dx-data-grid-comp"].instance;
    },
    /**
     * Get button label text for grid grid expand / collapse button
     */
    getLabel() {
      return this.expandChildGrid ? "Collapse" : "Expand";
    },
  },
  methods: {
    /**
     * Get Batch Data Grid Instance
     * @param LineNo
     * @returns {*}
     */
    getBatchDataGridInstance(LineNo) {
      const masterDetailComponent = this.$refs[`master-details-${LineNo}`];
      return typeof masterDetailComponent === "undefined"
        ? null
        : masterDetailComponent.instance;
    },

    /**
     * on date in filed validation
     */
    onDateInUpdate(e) {
      e.component.beginUpdate();
      e.component.option("value", e.previousValue);
      e.component.endUpdate();

      this.onHeaderFormItemFocus("DateIn");
    },
    /**
     * Credit Date Value change event
     * @param e
     */
    onCreditDateValueChanged(e) {
      if (e.event) {
        // if (e.value < this.CreditMinDate || e.value > this.CreditMaxDate) {
        //   e.component.beginUpdate();
        //   e.component.option("value", e.previousValue);
        //   e.component.endUpdate();
        // } else {
        this.updateDueDate(e);
        if (
          this.headerFormInstance &&
          this.headerFormInstance.getEditor("DueDate")
        ) {
          let dueDate = this.headerFormInstance.getEditor("DueDate").instance();
          dueDate.option("min", e.value);

          this.$nextTick(() => {
            if (this.ForwardTabOnCreditDate) {
              dueDate.focus();
              this.ForwardTabOnCreditDate = false;
            }
          });
        }
        // }
      }
    },

    /**
     * Credit Date field on key down
     * @param e
     */
    onCreditDateKeyDown(e) {
      this.ForwardTabOnCreditDate = !!(e.event && forwardTabbing(e));
    },

    /**
     *
     * @returns {Promise<void>}
     */
    async beforeInit() {
      /**
       * Do a parallel fetching Data
       */
      await Promise.all([
        this.fetchConfig(),
        this.fetchSupplierInvoiceDetails(),
        this.fetchSupplierInvoice(),
        this.fetchSupplierDetails(),
        this.getCompanyCurrencyCode(),
      ]);
      await this.initialized();
    },

    /**
     * Get Company Currency Code
     * @returns {Promise<void>}
     */
    async getCompanyCurrencyCode() {
      CompanyService.getCompany().then((res) => {
        let companyDetails = res.data.value[0];
        if (companyDetails) {
          this.BaseCurrency = companyDetails.CurrencyCode;
        } else {
          this.BaseCurrency = "AUD";
        }
      });
    },

    /**
     * initialized default data values
     */
    async initialized() {
      if (this.baseView.mode === "create") {
        this.MinDateIn = new Date();
        await this.setDateInValidation();

        this.setFooterItems([]);

        this.loaded = true;
      } else {
        this.loaded = true;
      }
    },

    /**
     * standard AP date validation rules
     */
    async setDateInValidation() {
      let currentInvoiceDate = undefined;
      if (this.baseView.mode === "review")
        currentInvoiceDate = new Date(this.MinDateIn.replace("Z", ""));
      else currentInvoiceDate = this.MinDateIn;

      let startDateResult =
        await SupplierInvoiceService.getActiveAccountingPeriodStartDate();
      if (startDateResult) {
        let accountingPeriod = new Date(
          startDateResult.data.value[0].StartDate.replace("Z", "")
        );

        if (
          this.baseView.mode === "review" &&
          currentInvoiceDate.getTime() > accountingPeriod.getTime()
        ) {
          this.MinDateIn = currentInvoiceDate;
        } else {
          this.MinDateIn = accountingPeriod;
        }
      } else {
        this.MinDateIn = currentInvoiceDate;
      }

      let endDateResult =
        await SupplierInvoiceService.getActiveAccountingPeriodEndDate();
      if (endDateResult) {
        let accountingPeriod = endDateResult.data.value[0].EndDate;
        this.CreditMaxDate = new Date(accountingPeriod.replace("Z", ""));
      }

      if (new Date(this.MinDateIn) < new Date(this.model.InvoiceDate)) {
        this.CreditMinDate = new Date(this.model.InvoiceDate);
      } else this.CreditMinDate = this.MinDateIn;
    },

    /**
     * Set Batch Credit Cell Value
     * @param newData
     * @param value
     * @param currentRowData
     * @returns {Promise<void>}
     */
    async onSetBatchCreditCellValue(newData, value, currentRowData) {
      if(currentRowData.SupplierReceivedQty > 0 && value > 0) value = -Math.abs(value);

      if (value > 0) {
        let alert = await this.$alert(
          `${currentRowData.BatchNo} has a required quantity of less than 0.00`,
          "Validation Error"
        );

        if (alert) {
          value = currentRowData.SupplierBatchCreditQty;
          newData.SupplierBatchCreditQty = value;

          setTimeout(() => {
            this.refocusOnBatchDataGrid(
              currentRowData,
              "SupplierBatchCreditQty"
            );
          }, 50);
        }

        return newData;
      } else if (
        currentRowData.SupplierAvailableQty >=
        currentRowData.OutstandingSupplierReturnQty
      ) {
        if (value < -currentRowData.OutstandingSupplierReturnQty) {
          /**
           * If the Available Qty >= Outstanding Qty, then Credit Qty must be >= negative of the Outstanding Qty and less than 0.00
           * @type {*|number}
           */
          await this.$alert(
            `${currentRowData.ItemCode} batch ${
              currentRowData.BatchNo
            } cannot be credited more than ${formatNumber(
              currentRowData.OutstandingSupplierReturnQty
            )} `,
            "Validation Error"
          );
          value = newData.SupplierBatchCreditQty;

          setTimeout(() => {
            this.refocusOnBatchDataGrid(
              currentRowData,
              "SupplierBatchCreditQty"
            );
          }, 50);
          return;
        }
      } else {
        if (value < -currentRowData.SupplierAvailableQty) {
          await this.$alert(
            `${currentRowData.ItemCode} batch ${
              currentRowData.BatchNo
            } cannot be returned more than ${formatNumber(
              currentRowData.SupplierAvailableQty
            )} `,
            "Validation Error"
          );
          value = newData.SupplierBatchCreditQty;

          setTimeout(() => {
            this.refocusOnBatchDataGrid(
              currentRowData,
              "SupplierBatchCreditQty"
            );
          }, 50);
          return;
        }
      }
      newData.SupplierBatchCreditQty = value;
      newData.IsChecked = value !== 0;
      this.IsBatchLineClicked = true;
      return newData;
    },

    /**
     * Cell focus on batch grid instance
     * @param lineInfo
     * @param columnName
     */
    refocusOnBatchDataGrid(lineInfo, columnName) {
      let batchInstance = this.getMasterDataInstance(lineInfo.ParentLineNo);
      if (batchInstance) {
        let rowIndex = batchInstance.getRowIndexByKey(lineInfo.BatchLineNo);
        if (rowIndex !== -1) {
          const cellElement = batchInstance.getCellElement(
            rowIndex,
            columnName
          );
          batchInstance.focus(cellElement);
          setTimeout(() => {
            this.$nextTick(() => {
              batchInstance.editCell(rowIndex, columnName);
            });
          }, 10);
        }
      }
    },

    /**
     * return batch grid instance
     * @param index - parent line line no
     */
    getMasterDataInstance(index) {
      return this.$refs["master-details-" + index].instance;
    },

    /**
     * on Set Credit Cell Value
     * @param newData
     * @param value
     * @param currentRowData
     */
    async onSetCreditCellValue(newData, value, currentRowData) {
      if (currentRowData.SupplierUMQuantity > 0 && value > 0)
        value = -Math.abs(value);

      let rowIndex = this.getDataGridInstance.getRowIndexByKey(
        currentRowData.LineNo
      );
      /**
       * Credit Qty cannot be more than 0.00
       */

      if (currentRowData.SupplierUMQuantity > 0 && value > 0) {
        let alert = await this.$alert(
          `${currentRowData.ItemDescription} has a required quantity of less than 0.00`,
          "Validation Error"
        );

        if (alert) {
          value = currentRowData.CreditQty;
          setTimeout(() => this.focusOnEditableCell(rowIndex, "CreditQty"), 50);
        }
        return;
      } else if (currentRowData.ItemType === "G") {
        if (value < -currentRowData.SupplierOutstandingQuantity) {
          await this.$alert(
            `${
              currentRowData.ItemDescription
            } cannot be credited more than ${formatNumber(
              currentRowData.SupplierOutstandingQuantity
            )} `,
            "Validation Error"
          );
          value = currentRowData.CreditQty;
          setTimeout(() => this.focusOnEditableCell(rowIndex, "CreditQty"), 50);
        }
      } else if (
        currentRowData.SupplierAvailableQuantity >=
        currentRowData.SupplierOutstandingQuantity
      ) {
        if (!(value >= -currentRowData.SupplierOutstandingQuantity)) {
          /**
           * If the Available Qty >= Outstanding Qty, then Credit Qty must be >= negative of the Outstanding Qty and less than 0.00
           * @type {*|number}
           */
          await this.$alert(
            `${
              currentRowData.ItemDescription
            } cannot be credited more than ${formatNumber(
              currentRowData.SupplierOutstandingQuantity
            )} `,
            "Validation Error"
          );
          value = currentRowData.CreditQty;
          setTimeout(() => this.focusOnEditableCell(rowIndex, "CreditQty"), 50);
        } else {
          if (!(value >= -currentRowData.SupplierAvailableQuantity)) {
            /**
             * If the Available Qty < the Outstanding Qty, then Credit Qty quantity must be >= negative of Available Qty and less than 0.00
             * @type {*|number}
             */
            await this.$alert(
              `${
                currentRowData.ItemDescription
              } cannot be returned more than ${formatNumber(
                currentRowData.SupplierAvailableQuantity
              )} `,
              "Validation Error"
            );
            value = currentRowData.CreditQty;
            setTimeout(
              () => this.focusOnEditableCell(rowIndex, "CreditQty"),
              50
            );
          }
        }
      } else if (
        currentRowData.SupplierAvailableQuantity <
          currentRowData.SupplierOutstandingQuantity &&
        value < -currentRowData.SupplierAvailableQuantity
      ) {
        /**
         * If the Available Qty < the Outstanding Qty, user can not credit more than the available qty
         */
        await this.$alert(
          `${
            currentRowData.ItemDescription
          } cannot be returned more than ${formatNumber(
            currentRowData.SupplierAvailableQuantity
          )} `,
          "Validation Error"
        );
        value = currentRowData.CreditQty;
        setTimeout(() => this.focusOnEditableCell(rowIndex, "CreditQty"), 50);
      }
      this.setCalculatedRow(newData, value, currentRowData);
    },

    /**
     * Calculated data On CreditQty Change
     * @param newData
     * @param value
     * @param currentRowData
     */
    setCalculatedRow(newData, value, currentRowData) {
      /**
       * set new data on credit qty
       */

      newData.CreditQty = value;
      newData.IsChecked = value !== 0;
      newData.TaxPcnt = currentRowData.TaxPcnt;

      /**
       * set FXPrice, FXTaxLineTotal in newData from currentRowData if not exist in a newData
       */
      if (currentRowData.FXPrice) {
        newData.FXPrice = currentRowData.FXPrice;
      } else {
        newData.FXPrice = 0;
      }
      if (currentRowData.FXIncTaxLineTotal) {
        newData.FXTaxLineTotal = currentRowData.FXIncTaxLineTotal;
      } else {
        newData.FXTaxLineTotal = 0;
      }

      /**
       * set exTotal Calculation
       * @type {number}
       */
      const exTotal = (newData.CreditQty * newData.FXPrice).roundNumber(2);
      newData.Amount = exTotal;

      /**
       * set tax calculation
       * @type {number}
       */
      const tax = (exTotal * (currentRowData.TaxRate / 100)).roundNumber(2);
      newData.FXTaxLineTotal = tax;

      /**
       * set Total include tax
       * @type {number}
       */
      newData.FXIncTaxLineTotal = (exTotal + tax).roundNumber(2);

      return newData;
    },

    /**
     * handle on credit qty keydown
     * @param e
     * @param lineData
     */
    onCreditQtyKeyDown(e, lineData) {
      if (backwardTabbing(e)) {
        // e.event.preventDefault();
        this.removeGridFocusRow();
        if (lineData.data.rowIndex === 0) {
          e.event.preventDefault();
          this.onHeaderFormItemFocus("Rounding");
        } else {
          let gridInstance = this.getDataGridInstance;
          let prevRowKey = gridInstance.getKeyByRowIndex(
            lineData.data.rowIndex - 1
          );

          if (prevRowKey !== -1) {
            gridInstance.byKey(prevRowKey).then((prevItem) => {
              if (prevItem.IsBatchProduct === "No") {
                // Prev Items is not Batch
                let rowIndex = gridInstance.getRowIndexByKey(prevItem.LineNo);
                this.focusOnEditableCell(rowIndex, "Comments");
              } else {
                // Prev Items is Batch
                this.moveIntoLastFieldInBatch(e, prevItem);
              }
            });
          } else {
            this.onHeaderFormItemFocus("Rounding");
            this.removeGridFocusRow();
          }
        }
      }
    },

    /**
     * Set on Tax Field Keydown
     * @param e
     */
    onTaxKeydown(e) {
      if (forwardTabbing(e)) {
        e.event.preventDefault();
        let gridInstance = this.getDataGridInstance;

        let items = gridInstance.getDataSource().items();
        let dataField = undefined;
        if (items.length > 0) {
          if (items[0].IsBatchProduct === "No") {
            dataField = "CreditQty";
          } else {
            dataField = "Comments";
          }
          this.focusOnEditableCell(0, dataField);
        }
      }
    },

    /**
     * on grid comment cell key down press - check for tab key event
     * @param e
     * @param cellInfo
     */
    onCommentsKeyDown(e, cellInfo) {
      if (e.event) {
        let gridInstance = this.getDataGridInstance;
        let data = cellInfo.data.data;

        if (forwardTabbing(e)) {
          if (data.IsBatchProduct !== "No") {
            e.event.preventDefault();
            this.moveIntoFirstEditableCellInBatch(cellInfo);
          } else {
            let rowIndex = gridInstance.getRowIndexByKey(data.LineNo);
            let nextRowKey = gridInstance.getKeyByRowIndex(rowIndex + 1);

            if (nextRowKey) {
              gridInstance.byKey(nextRowKey).then((res) => {
                if (res.IsBatchProduct !== "No") {
                  e.event.preventDefault();
                  this.focusOnEditableCell(rowIndex + 1, "Comments");
                }
              });
            }
          }
        }

        if (backwardTabbing(e)) {
          let prevRowKey = gridInstance.getKeyByRowIndex(
            cellInfo.data.rowIndex - 1
          );

          if (data.IsBatchProduct !== "No") {
            gridInstance.option("focusedRowIndex", -1);
            e.event.preventDefault();

            if (cellInfo.data.rowIndex !== 0 && prevRowKey !== -1) {
              gridInstance.byKey(prevRowKey).then((prevItem) => {
                if (prevItem.IsBatchProduct === "No") {
                  // Prev Items is not Batch
                  let rowIndex = gridInstance.getRowIndexByKey(prevItem.LineNo);
                  this.focusOnEditableCell(rowIndex, "Comments");
                } else {
                  // Prev Items is Batch
                  this.moveIntoLastFieldInBatch(e, prevItem);
                }
              });
            } else {
              this.onHeaderFormItemFocus("Rounding");
              this.removeGridFocusRow();
            }
          }
        }
      }
    },

    /**
     * move into the 1st editable cell in batch grid
     * @param cellInfo
     */
    moveIntoFirstEditableCellInBatch(cellInfo) {
      let gridInstance = this.getDataGridInstance;
      let data = cellInfo.data.data;
      gridInstance.expandRow(cellInfo.data.key).then(() => {
        setTimeout(() => {
          let batchGridInstance = this.getMasterDataInstance(
            data.LineNo
          );
          let items = batchGridInstance.getDataSource().items();

          if (batchGridInstance) this.BatchGridInstance = batchGridInstance;

          if (items.length > 0) {
            let dataField = "SupplierBatchCreditQty";
            if (batchGridInstance) {
              let cellElement = batchGridInstance.getCellElement(0, dataField);
              let rowIndex = batchGridInstance.getRowIndexByKey(
                items[0].BatchLineNo
              );
              if (cellElement) {
                batchGridInstance.focus(cellElement);
                setTimeout(() => {
                  batchGridInstance.editCell(rowIndex, dataField);
                }, 1);
              }
            }
          }
        }, 10);
      });
    },

    /**
     * move into the last row, last editable cell in batch grid
     * @param e
     * @param prevItem
     */
    moveIntoLastFieldInBatch(e, prevItem) {
      let gridInstance = this.getDataGridInstance;
      gridInstance.expandRow(prevItem.LineNo).then(() => {
        let batchGridInstance = this.getMasterDataInstance(
          prevItem.ParentLineNo
        );
        if (batchGridInstance) this.BatchGridInstance = batchGridInstance;
        let items = batchGridInstance.getDataSource().items();

        if (items.length > 0) {
          e.event.preventDefault();

          let dataField = "SupplierBatchCreditQty";

          if (batchGridInstance) {
            let cellElement = batchGridInstance.getCellElement(
              items.length - 1,
              dataField
            );
            if (cellElement) {
              let rowIndex = batchGridInstance.getRowIndexByKey(
                items[items.length - 1].BatchLineNo
              );
              batchGridInstance.focus(cellElement);
              setTimeout(() => {
                batchGridInstance.editCell(rowIndex, dataField);
              }, 1);
            }
          }
        }
      });
    },

    /**
     * Focus method on Editable Cell
     * @param rowIndex
     * @param columnName
     */
    focusOnEditableCell(rowIndex, columnName) {
      this.removeBatchGridFocus();
      const dataGrid = this.getDataGridInstance;

      const cellElement = dataGrid.getCellElement(rowIndex, columnName);
      dataGrid.focus(cellElement);
      setTimeout(() => {
        dataGrid.editCell(rowIndex, columnName);
      }, 10);
    },

    /**
     * Handle click open new window
     * @param data
     */
    onHandleClick(data) {
      const fieldValue = data.data[data.column.dataField];
      let baseUrl = process.env.VUE_APP_BASE_URL;
      let url = "";
      if (baseUrl === "/")
        url = `${baseUrl}${data.column.hyperlink.url.replace(
          "__ID__",
          fieldValue
        )}`;
      else url = `/${data.column.hyperlink.url.replace("__ID__", fieldValue)}`;
      const route = this.$router.resolve({ path: url });
      window.open(route.href, data.column.hyperlink.target);
    },

    /**
     * Set Tick UnTick
     * @param LineNoList
     * @param isTick
     */
    setTickUnTickBatch(LineNoList, isTick = true) {
      /**
       * Handling UI: Ticking checkbox in table header, will tick all the enabled lines.
       */
      LineNoList.map((LineNo) => {
        const batchDataGridInstance = this.getBatchDataGridInstance(LineNo);
        if (batchDataGridInstance) {
          const BatchLineNo = [];
          batchDataGridInstance.getDataSource()._items.map((batchItem) => {
            batchItem.IsChecked = isTick;
            BatchLineNo.push(batchItem.BatchLineNo);
          });
          if (isTick) {
            batchDataGridInstance.selectRows(BatchLineNo);
          } else {
            batchDataGridInstance.deselectRows(BatchLineNo);
          }
        }
      });
    },

    /**
     * Handle on selection change
     * @param e
     */
    onSelectionChanged(e) {
      const rowIndexes = [];
      let items = e.component.getDataSource().items();
      let disabledItems = items.filter((x) => x.IsDisabled);
      let totalChecked = items.filter((x) => x.IsChecked);
      if (
        disabledItems.length > 0 &&
        items.length - disabledItems.length === totalChecked.length &&
        e.selectedRowsData.length === items.length
      ) {
        e.component.deselectAll();
      } else {
        /**
         * check all selected rows
         */
        if (e.currentSelectedRowKeys.length > 0) {
          if (this.IsBatchLineClicked) {
            this.IsBatchLineClicked = false;
            return;
          }
          const batchLineNoList = [];
          /**
           * find selected Data based on LineNo. LineNo start from 1 and selectedRow start from 0
           */
          e.currentSelectedRowKeys.map((element) => {
            let newData = e.selectedRowsData.find(
              (item) => item.LineNo === element
            );
            /**
             * Handling disable checkbox
             */
            if (newData.IsDisabled) {
              e.component.deselectRows([newData.LineNo]);
              e.selectedRowsData = e.selectedRowsData.filter(
                (item) => item.LineNo !== element
              );
            } else {
              /**
               * Expand batch if IsBatchProduct !== "No"
               */
              if (newData.IsBatchProduct !== "No") {
                e.component.expandRow(newData.LineNo);
              }
              batchLineNoList.push(newData.LineNo);

              if (newData.CreditQty === 0) {
                if (newData.ItemType === "G")
                  newData.CreditQty = newData.SupplierOutstandingQuantity * -1;
                else if (
                  newData.SupplierOutstandingQuantity >
                  newData.SupplierAvailableQuantity
                )
                  newData.CreditQty = newData.SupplierAvailableQuantity * -1;
                else
                  newData.CreditQty = newData.SupplierOutstandingQuantity * -1;
                newData = this.setCalculatedRow(
                  newData,
                  newData.CreditQty,
                  newData
                );
                this.localDataSource
                  .update(newData.LineNo, newData)
                  .then(() => {
                    let rowIndex = e.component.getRowIndexByKey(newData.LineNo);
                    rowIndexes.push(rowIndex);
                  });
              }
            }
          });
          setTimeout(() => this.setTickUnTickBatch(batchLineNoList), 10);
        }
        if (e.currentDeselectedRowKeys.length > 0) {
          this.IsBatchLineClicked = false;
          const batchLineNoList = [];
          /**
           * find deselected Data.
           */
          e.currentDeselectedRowKeys.map((element) => {
            e.component.byKey(element).then((item) => {
              item = this.setDefaultValues(item);
              batchLineNoList.push(item.LineNo);

              this.localDataSource.update(item.LineNo, item).then(() => {
                let rowIndex = e.component.getRowIndexByKey(item.LineNo);
                rowIndexes.push(rowIndex);
              });
            });
          });
          setTimeout(() => this.setTickUnTickBatch(batchLineNoList, false), 10);
        }
        this.selectedRows = e.selectedRowsData;
      }

      this.updateFooter();
      e.component.repaintRows(rowIndexes);
    },

    /**
     * Fetch Supplier Invoice
     * @returns {Promise<void>}
     */
    async fetchSupplierInvoice() {
      try {
        const Response = await SupplierInvoiceService.getByCode(
          this.baseView.id
        );
        const SupplierInvoice = Response.data.value[0];
        /**
         * Set Data To Model
         */
        this.model.SupplierName = SupplierInvoice.SupplierName;
        this.model.CurrencyCode = SupplierInvoice.CurrencyCode;
        this.model.DueDate = SupplierInvoice.DueDate;
        this.model.Status = SupplierInvoice.FriendlyStatus;
        this.model.Invoice = SupplierInvoice.InvoiceNo;
        this.model.SupplierCode = SupplierInvoice.SupplierCode;
        this.model.InvoiceDate = SupplierInvoice.InvoiceDate;
        this.model.SourceSupplierInvoiceCode = SupplierInvoice.Code;
        this.model.DateChanged = SupplierInvoice.DateChanged;

        const currency = await CompanyCurrencyService.getByCurrencyCode(
          this.model.CurrencyCode,
          {
            select: ["CurrencyCode", "SellRate"],
          }
        );

        if (currency.data.value.length === 0) this.model.ExchangeRate = 1;
        else this.model.ExchangeRate = currency.data.value[0].SellRate;
      } catch (e) {
        this.displayServerError(e, "Failed to fetch Supplier Invoice");
      }
    },

    /**
     * Fetch Screen Config
     * @returns {Promise<void>}
     */
    async fetchConfig() {
      try {
        const result = await SettingsService.getBySettingName("ReSupplyOrder");
        this.screenSettings = result.data.value;
        if (this.screenSettings.length > 0) {
          let settingScope = this.screenSettings.find(
            (x) => x.ScopeCode === "Global"
          );
          if (settingScope && settingScope.SettingValue === "Y") {
            this.model.Resupply = true;
          }
        }
      } catch (e) {
        this.displayServerError(e, "Failed to fetch the config");
      }
    },

    /**
     * Set Default Values
     * @param item
     * @returns {*}
     */
    setDefaultValues(item) {
      item.IsChecked = false;
      item.CreditQty = 0;
      item.Amount = 0;
      item.FXTaxLineTotal = 0;
      item.FXIncTaxLineTotal = 0;
      item.Comments = "";
      return item;
    },

    /**
     * Fetch Invoice Details Service By Code and throw the error once the data not found
     * @returns {Promise<void>}
     */
    async fetchSupplierInvoiceDetails() {
      try {
        const supplierInvoiceDetails =
          await SupplierInvoiceDetailsService.getByCode(this.baseView.id);
        const purchaseOrders = [];
        /**
         * Set Data
         */
        supplierInvoiceDetails.data.value.map((item, index) => {
          item.ID = index;
          if (item.SupplierAvailableQuantity < 0) {
            item.SupplierAvailableQuantity = 0;
          }
          item = this.setDefaultValues(item);
          item.IsDisabled = false;
          if (item.ItemType === "G" && item.SupplierOutstandingQuantity === 0) {
            item.IsDisabled = true;
          } else if (
            item.ItemType === "S" &&
            (item.SupplierOutstandingQuantity === 0 ||
              item.SupplierAvailableQuantity === 0)
          ) {
            item.IsDisabled = true;
          }
          const purchaseOrder = purchaseOrders.find(
            (po) => po === item.PurchaseOrderCode
          );
          if (!purchaseOrder) {
            purchaseOrders.push(item.PurchaseOrderCode);
          }
          item.ChildDataSource = new ArrayStore({
            key: "BatchLineNo",
            data: [],
          });
          this.localDataSource.insert(item);
          if (item.IsBatchProduct !== "No") {
            this.IsBatchAvailable = true;
            this.fetchBatchItems(item);
          }
        });

        /**
         * check Multiple Purchase order or not
         */
        if (purchaseOrders.length > 1) {
          this.model.PurchaseOrder = "Multiple";
        } else {
          this.model.PurchaseOrder = purchaseOrders[0];
        }
      } catch (e) {
        await this.displayError(e);
      }
    },

    /**
     * Fetch batch items for the related invoice line items
     * @param item - line item
     */
    async fetchBatchItems(item) {
      try {
        const result = await GoodsInReviewService.getGoodsInBatches(
          item["GoodsInCode"],
          item["GoodsInLineNo"]
        );

        if (result.data.value.length > 0) {
          result.data.value.forEach((element, index) => {
            if (
              element.SupplierReceivedQty > 0 &&
              element.SupplierAvailableQty < 0
            ) {
              element.SupplierAvailableQty = 0;
            }
            element.SupplierBatchCreditQty = 0;
            element.BatchLineNo = index;
            element.IsChecked = false;
            element.ParentLineNo = item.LineNo;

            element.IsDisabled =
              element.OutstandingSupplierReturnQty === 0 ||
              element.SupplierAvailableQty === 0;
          });

          this.localDataSource.update(item.LineNo, {
            ChildDataSource: new ArrayStore({
              key: "BatchLineNo",
              data: result.data.value,
            }),
          });
        }
      } catch (e) {
        await this.displayError(e);
      }
    },

    /**
     * Fetch Supplier details
     * @returns {Promise<void>}
     */
    async fetchSupplierDetails() {
      try {
        const result = await SupplierService.getByCode(
          this.model.SupplierCode,
          {
            select: ["Code", "Name", "Terms", "TermCalculation"],
          }
        );
        if (result.data.value.length > 0) {
          this.supplierData = result.data.value[0];
          this.model.TermCalculation = this.supplierData.TermCalculation;
          this.model.Terms = this.supplierData.Terms;
          // Update the due date according to the sup rules.
          this.updateDueDate({ value: new Date() });
        }
      } catch (e) {
        this.supplierData = undefined;
        await this.displayError(e);
      }
    },

    /**
     * Display server error
     */
    async displayError(e) {
      this.displayServerError(e, "Server Error");
    },

    /**
     * Back Button Function
     */
    backButtonFunction() {
      this.$router.push({
        path: this.backButtonRoute,
      });
    },

    /**
     * On Header Form Content Ready
     * @param e
     */
    onHeaderFormContentReady(e) {
      const headerForm = document.querySelectorAll(".gc-header-form");
      this.headerFormHeight = headerForm[0].clientHeight;

      this.headerDxFormHeight = e.element.offsetHeight;
      this.headerFormInstance = e.component;

      this.onHeaderFormItemFocus("DateIn");
    },
    /**
     * Focus on field in header form component
     * @param dataField
     */
    onHeaderFormItemFocus(dataField) {
      this.$nextTick(() => {
        if (
          this.headerFormInstance &&
          this.headerFormInstance.getEditor(dataField)
        )
          this.headerFormInstance.getEditor(dataField).instance().focus();
      });
    },

    /**
     * Data grid editors are preparing
     * @param e
     */
    onEditorPreparing(e) {
      if (e.command === "select" && e.row) {
        if (e.row.data.ChildDataSource._array.length > 0) {
          e.row.data.IsDisabled = !!e.row.data.ChildDataSource._array.find(
            (item) => item.IsDisabled
          );
        }
        if (e.row.data.IsDisabled) {
          e.editorOptions.disabled = e.row.data.IsDisabled;
        }
      }

      /**
       * Disable editor for negative values in SupplierUMQuantity
       */
      if (
        e.parentType === "dataRow" &&
        e.dataField === "SupplierUMQuantity" &&
        e.data.value < 0
      ) {
        e.cancel = true;
      }

      if (e.editorOptions && e.editorOptions.onKeyDown) {
        let func = e.editorOptions.onKeyDown;
        if (this.baseView.mode !== "review" && e.parentType !== "searchPanel")
          e.editorOptions.onKeyDown = (event) => {
            func(event, {
              data: e.row,
            });
          };
      }

      if (e.parentType === "headerRow") {
        e.editorOptions.onInitialized = (e) => {
          if (e.component) this.selectAllCheckBox = e.component;
        };
      }
    },

    /**
     * SetParentSelectedRows
     * @param component
     */
    setParentSelectedRows(component) {
      const selectedIds = this.localDataSource._array
        .filter((item) => item.IsChecked)
        .map((row) => row.LineNo);
      component.selectRows(selectedIds, true);
      const deSelectedIds = this.localDataSource._array
        .filter((item) => !item.IsChecked)
        .map((row) => row.LineNo);
      component.deselectRows(deSelectedIds, true);
      this.updateFooter();
    },

    /**
     * Handling on row Updated
     */
    onRowUpdated(e) {
      this.setParentSelectedRows(e.component);
    },

    /**
     * On Row Batch Update
     * @param e
     */
    onBatchRowUpdated(e) {
      const parent = this.localDataSource._array.find(
        (item) => item.LineNo === e.data.ParentLineNo
      );
      const selectedIds = parent.ChildDataSource._array
        .filter((item) => item.IsChecked)
        .map((row) => row.BatchLineNo);
      e.component.selectRows(selectedIds, true);
      const deSelectedIds = parent.ChildDataSource._array
        .filter((item) => !item.IsChecked)
        .map((row) => row.BatchLineNo);
      e.component.deselectRows(deSelectedIds, true);
      this.updateParent(parent.LineNo);
    },
    /**
     * on batch grid cell editor preparing
     * @param e
     */
    onBatchEditorPreparing(e) {
      if (e.editorOptions && e.editorOptions.onKeyDown) {
        let func = e.editorOptions.onKeyDown;
        if (this.baseView.mode !== "review" && e.parentType !== "searchPanel")
          e.editorOptions.onKeyDown = (event) => {
            func(event, {
              data: e.row,
              component: e.component,
            });
          };
      }
      if (e.parentType === "dataRow") {
        e.editorOptions.disabled = e.row.data.IsDisabled;
      }

      if (e.parentType === "headerRow") {
        e.editorOptions.onInitialized = (e) => {
          if (e.component) this.selectAllBatchCheckBox.push(e.component);
        };
      }
    },

    /**
     * on data grid tool bar preparing
     */
    onToolbarPreparing(e) {
      var toolbarItems = e.toolbarOptions.items;
      var searchPanel = toolbarItems.find((item) => {
        return item.name === "searchPanel";
      });
      searchPanel.location = "after";

      e.toolbarOptions.items.push({
        location: "before",
        widget: "dxButton",
        options: {
          icon: this.expandChildGrid ? "chevronup" : "chevrondown",
          text: this.getLabel,
          onClick: () => {
            this.expandMasterDetailsSection();
          },
          onContentReady: (e) => {
            this.CollapseBtnContentReady = e;
          },
          visible: this.IsBatchAvailable,
        },
      });

      e.toolbarOptions.items.push({
        location: "after",
        locateinmenu: "auto",
        widget: "dxButton",
        options: {
          icon: this.gridExpand ? "collapse" : "expand",
          onClick: this.expandGrid,
          elementAttr: {
            id: "so-v4-grid-expand",
          },
        },
      });
    },

    /**
     * Expan grid component & hide header form component
     */
    expandGrid() {
      this.$store.dispatch("ui/setGridExpand", !this.gridExpand);
      this.$nextTick(() => {
        var dataGrid = this.getDataGridInstance;

        dataGrid.beginUpdate();
        dataGrid.updateDimensions();
        dataGrid.endUpdate();

        dataGrid.refresh(true);
      });
    },

    /**
     * on data grid content ready
     */
    onContentReady(e) {
      if (e && this.gridDataLoaded === false) {
        this.gridDataLoaded = true;
        this.$nextTick(() => {
          this.expandMasterDetailsSection();
        });
      }
    },

    /**
     * on main data grid focus celll changed
     */
    onFocusedCellChanged() {
      this.removeBatchGridFocus();
    },

    /**
     * on data grid cell editing starting
     */
    onEditingStart(e) {
      let data = e.data;

      if (e.column.dataField === "CreditQty") {
        if (
          data.IsBatchProduct !== "No" ||
          data.SupplierUMQuantity < 0 ||
          data.IsDisabled
        ) {
          e.cancel = true;
        }
      }
    },

    /**
     * on batch data grid cell editing starting
     * @param e
     */
    onBatchEditingStart(e) {
      const data = e.data;
      if (e.column.dataField === "SupplierBatchCreditQty") {
        if (data.SupplierReceivedQty < 0 || data.IsDisabled) {
          e.cancel = true;
        }
      }
    },

    /**
     * on data grid cell prepared
     * @param e - cell event
     */
    onCellPrepared(e) {
      if (e.rowType === "data" && e.column.command === "expand") {
        if (e.data.IsBatchProduct === "No") {
          if (e.cellElement && e.cellElement.classList) {
            e.cellElement.classList.remove("dx-datagrid-expand");
            e.cellElement.childNodes[0].classList.remove(
              "dx-datagrid-group-closed"
            );
          }
        }
      }
    },

    /**
     * Expand / Collapse child grid rows
     */
    expandMasterDetailsSection() {
      let gridInstance = this.getDataGridInstance;

      let items = this.localDataSource._array;
      if (this.expandChildGrid) {
        this.expandChildGrid = false;
        // gridInstance.collapseAll(-1);
        items.forEach((element, index) => {
          if (
            element.ChildDataSource &&
            element.ChildDataSource._array.length > 0
          ) {
            setTimeout(() => {
              gridInstance.collapseRow(element.LineNo);
            }, 100 * index);
          }
        });
      } else {
        this.expandChildGrid = true;
        items.forEach((element, index) => {
          if (
            element.ChildDataSource &&
            element.ChildDataSource._array.length > 0
          ) {
            setTimeout(() => {
              gridInstance.expandRow(element.LineNo);
            }, 100 * index);
          }
        });
      }
      setTimeout(() => {
        gridInstance.refresh(true).then(() => {
          if (this.CollapseBtnContentReady) {
            this.CollapseBtnContentReady.component.beginUpdate();
            this.CollapseBtnContentReady.component.option(
              "text",
              this.getLabel
            );
            this.CollapseBtnContentReady.component.option(
              "icon",
              this.expandChildGrid ? "chevronup" : "chevrondown"
            );
            this.CollapseBtnContentReady.component.endUpdate();
          }
        });
      }, 100);
    },

    /**
     * Remove Focus on DataGrid
     */
    removeGridFocusRow() {
      if (this.getDataGridInstance) {
        this.getDataGridInstance.option("focusedRowIndex", -1);
      }
    },

    /**
     * Remove Focus on Batch DataGrid
     */
    removeBatchGridFocus() {
      if (this.BatchGridInstance)
        this.BatchGridInstance.option("focusedRowIndex", -1);
    },

    // Batch Grid Related
    /**
     * Batch grid columns based on the product attributes
     * @param data - parent line info
     */
    getChildGridColumns(data) {
      let item = data.data;

      let visibleUseBy = true;
      let visibleBestBefore = true;

      if (item.UseByShelfLife === -1 && item.BestBeforeShelfLife === -1) {
        visibleUseBy = false;
        visibleBestBefore = false;
      } else if (item.UseByShelfLife > -1 && item.BestBeforeShelfLife > -1) {
        visibleBestBefore = false;
      } else if (item.UseByShelfLife > -1) {
        visibleBestBefore = false;
      } else if (item.BestBeforeShelfLife > -1) {
        visibleUseBy = false;
      }

      return this.parseColumnWithScreenFields([
        {
          screenField: "Batch",
          dataField: "BatchNo",
          showEditorAlways: false,
          width: ColumnWidth.BatchNo.width + 27,
          minWidth: ColumnWidth.BatchNo.minWidth,
          allowEditing: false,
        },
        {
          screenField: "SupplierBatchNo",
          cssClass: "edit-cell-textbox-field",
          allowEditing: false,
          width: ColumnWidth.SupplierBatchNo.width + 395,
          minWidth: ColumnWidth.SupplierBatchNo.minWidth + 215,
        },
        {
          screenField: "Quantity",
          dataField: "SupplierReceivedQty",
          format: "Decimal-16-2",
          caption: "Invoiced",
          width: ColumnWidth.Quantity2DecimalPoints.width,
          maxWidth: ColumnWidth.Quantity2DecimalPoints.maxWidth,
        },
        {
          screenField: "Quantity",
          dataField: "OutstandingSupplierReturnQty",
          caption: "Outstanding",
          cellTemplate: "Decimal",
          minWidth: ColumnWidth.Quantity.width,
          width: ColumnWidth.Quantity.minWidth,
          format: "##,###,###,###,##0.00",
          allowEditing: false,
        },
        {
          screenField: "Quantity",
          dataField: "SupplierAvailableQty",
          caption: "Available",
          minWidth: ColumnWidth.Quantity.width,
          width: ColumnWidth.Quantity.minWidth,
          cellTemplate: "Decimal",
          format: "##,###,###,###,##0.00",
          dataType: "number",
          allowEditing: false,
        },
        {
          screenField: "Quantity",
          dataField: "SupplierBatchCreditQty",
          format: "##,###,###,###,##0.00",
          cssClass: "edit-cell-numberbox-field",
          showEditorAlways: false,
          allowEditing: !item.IsDisabled,
          caption: "Credit",
          cellTemplate: "Decimal",
          width: ColumnWidth.Quantity2DecimalPoints.width,
          maxWidth: ColumnWidth.Quantity2DecimalPoints.maxWidth,
          editorOptions: {
            format: "##,###,###,###,##0.00",
            onFocusIn: (e) => {
              e.event.target.select();
            },
            onKeyDown: this.onSupplierBatchCreditQtyKeyDown,
          },
          setCellValue: this.onSetBatchCreditCellValue,
        },
        {
          screenField: "DateIn",
          caption: "Manufactured Date",
          dataField: "ManufacturedDate",
          allowEditing: false,
          allowSearch: false,
          dataType: "date",
          width: ColumnWidth.Date.width,
          minWidth: ColumnWidth.Date.minWidth,
          format: "dd MMM yyyy",
        },
        {
          screenField: "UseByDate",
          allowEditing: false,
          allowSearch: false,
          showEditorAlways: false,
          dataType: "date",
          width: ColumnWidth.Date.width,
          minWidth: ColumnWidth.Date.minWidth,
          visible: visibleUseBy,
          format: "dd MMM yyyy",
        },
        {
          screenField: "BestBeforeDate",
          allowEditing: false,
          allowSearch: false,
          showEditorAlways: false,
          dataType: "date",
          width: ColumnWidth.Date.width,
          minWidth: ColumnWidth.Date.minWidth,
          visible: visibleBestBefore,
          format: "dd MMM yyyy",
        },
      ]);
    },

    /**
     *
     * @param e
     * @param cellInfo
     */
    onSupplierBatchCreditQtyKeyDown(e, cellInfo) {
      if (e.event) {
        let batchGridInstance = cellInfo.component;
        if (forwardTabbing(e)) {
          let data = cellInfo.data.data;
          let gridInstance = this.getDataGridInstance;
          if (batchGridInstance) this.BatchGridInstance = batchGridInstance;
          let items = batchGridInstance.getDataSource().items();

          let rowIndex = cellInfo.data.rowIndex;
          if (rowIndex === items.length - 1) {
            // e.event.preventDefault();

            const gridDS = gridInstance.getDataSource();
            const loadOptions = gridDS.loadOptions();

            gridDS
              .store()
              .load(loadOptions)
              .done((loadedItems) => {
                let parentRowIndex = loadedItems.findIndex(
                  (x) => x.LineNo === data.ParentLineNo
                );
                let nextRowIndex = parentRowIndex + 1;

                let nextRow = loadedItems[nextRowIndex];

                setTimeout(() => {
                  if (nextRow) {
                    let dataField;
                    if (nextRow.IsBatchProduct === "No") {
                      dataField = "CreditQty";
                    } else {
                      dataField = "Comments";
                    }
                    let rowIndex = gridInstance.getRowIndexByKey(
                      nextRow.LineNo
                    );
                    this.focusOnEditableCell(rowIndex, dataField);
                  }
                }, 10);
              });
          }
        }

        if (backwardTabbing(e)) {
          if (cellInfo.data.rowIndex === 0) {
            if (batchGridInstance) this.BatchGridInstance = batchGridInstance;
            batchGridInstance.option("focusedRowIndex", -1);
            e.event.preventDefault();
            let data = cellInfo.data.data;
            let instance = this.getDataGridInstance;
            let parentRowIndex = instance.getRowIndexByKey(data.ParentLineNo);

            this.focusOnEditableCell(parentRowIndex, "Comments");
          }
        }
      }
    },

    /**
     * on batch grid focus cell changed
     */
    onBatchFocusedCellChanged(e) {
      this.removeGridFocusRow();

      if (e) {
        this.BatchGridInstance = e.component;
      }
    },

    /**
     * on batch grid line selection changed
     */

    onBatchSelectionChanged(e) {
      let items = e.component.getDataSource().items();
      let disabledItems = items.filter((x) => x.IsDisabled);
      let totalChecked = items.filter((x) => x.IsChecked);
      if (
        disabledItems.length > 0 &&
        items.length - disabledItems.length === totalChecked.length &&
        e.selectedRowsData.length === items.length
      ) {
        e.component.deselectAll();
      } else {
        let ParentLineNo = null;
        if (e.currentSelectedRowKeys.length > 0) {
          e.selectedRowsData.map((batch) => {
            if (batch.IsDisabled) {
              e.component.deselectRows([batch.BatchLineNo]);
            } else {
              this.IsBatchLineClicked = true;
              ParentLineNo = batch.ParentLineNo;
              if (batch.SupplierBatchCreditQty === 0) {
                if (
                  batch.SupplierAvailableQty >
                  batch.OutstandingSupplierReturnQty
                ) {
                  batch.SupplierBatchCreditQty =
                    batch.OutstandingSupplierReturnQty * -1;
                } else if (
                  batch.SupplierAvailableQty <
                  batch.OutstandingSupplierReturnQty
                ) {
                  batch.SupplierBatchCreditQty =
                    batch.SupplierAvailableQty * -1;
                } else {
                  batch.SupplierBatchCreditQty = batch.SupplierReceivedQty * -1;
                }
                batch.IsChecked = true;
              }
            }
          });
        }

        if (e.currentSelectedRowKeys.length === 0)
          this.IsBatchLineClicked = false;

        if (e.currentDeselectedRowKeys.length > 0) {
          /**
           * find deselected Data.
           */
          e.currentDeselectedRowKeys.map((element) => {
            e.component.byKey(element).then((batch) => {
              batch.SupplierBatchCreditQty = 0;
              ParentLineNo = batch.ParentLineNo;
              batch.IsChecked = false;
            });
          });
        }
        if (ParentLineNo !== null) {
          this.updateParent(ParentLineNo);
        }

        let batchKeys = [];
        disabledItems.forEach((element) => {
          batchKeys.push(element.BatchLineNo);
        });
        if (batchKeys.length > 0 && e.selectedRowsData.length === items.length)
          e.component.deselectRows(batchKeys);
      }
    },

    /**
     * Update Parent
     * @param ParentInLineNo
     */
    updateParent(ParentInLineNo) {
      const rowIndexes = [];
      const dataGrid = this.getDataGridInstance;
      dataGrid.byKey(ParentInLineNo).then((parent) => {
        parent.CreditQty = parent.ChildDataSource._array.reduce((x, y) => {
          return x + y.SupplierBatchCreditQty;
        }, 0);

        parent = this.setCalculatedRow(parent, parent.CreditQty, parent);
        this.localDataSource.update(parent.LineNo, parent).then(() => {
          let rowIndex = dataGrid.getRowIndexByKey(parent.LineNo);
          rowIndexes.push(rowIndex);
        });
      });
      dataGrid.repaintRows(rowIndexes);
      this.setParentSelectedRows(dataGrid);
    },

    /**
     * Update due date based on the 'Credit Date' value
     * @param e
     */
    updateDueDate(e) {
      if (!this.supplierData) return;
      else {
        // this.DueDateMin = e.value;
        let year = new Date(e.value).getFullYear();
        let month = new Date(e.value).getMonth();
        if (this.supplierData.TermCalculation === "ACTUAL") {
          this.model.DueDate = new Date(e.value).addDays(
            this.supplierData.Terms
          );
        } else if (
          this.supplierData.TermCalculation === "EOM" &&
          this.supplierData.Terms % 30 === 0
        ) {
          this.model.DueDate = new Date(
            year,
            month + this.supplierData.Terms / 30 + 1,
            0
          );
        } else if (this.supplierData.TermCalculation === "SPLIT") {
          let calculatedDate = new Date(this.model.CreditDate);
          if (calculatedDate.getDate() <= 15) {
            this.model.DueDate = new Date(
              calculatedDate.getFullYear(),
              calculatedDate.getMonth() + 1,
              0
            );
          } else {
            this.model.DueDate = new Date(
              calculatedDate.getFullYear(),
              calculatedDate.getMonth() + 1,
              16
            );
          }
        } else {
          this.model.DueDate = new Date(year, month + 1, 0).addDays(
            this.supplierData.Terms
          );
        }
      }
    },

    /**
     * Store Transaction
     * @param isValid
     * @returns {Promise<void>}
     */
    async saveTransaction(isValid) {
      const balance = this.footerItems.find(
        (item) => item.dataField === "Balance"
      ).value;
      if (
        this.localDataSource._array.filter((item) => item.IsChecked).length ===
        0
      ) {
        this.addToValidationSum(
          "Supplier Credit has no detail. Please add one or more lines before attempting to save the transaction again."
        );
        return;
      } else if (balance !== 0) {
        this.addToValidationSum("Supplier Credit is not balanced");
        return;
      }

      /** TODO: Mapping tye payload
       * set main payload
       */

      this.model.FXFreight = 0;
      this.model.GstAmount = this.footerItems.find(
        (item) => item.dataField === "TaxFXTotal"
      ).value;

      if (isValid) {
        // eslint-disable-next-line no-unused-vars
        const { Total, Invoice, PurchaseOrder, Status, ...payload } =
          this.model;
        payload.FXAmount = Total;
        payload.InvoiceNo = Invoice;
        payload.PurchaseOrderCode =
          PurchaseOrder === "Multiple" ? 0 : PurchaseOrder;
        payload.Resupply = payload.Resupply ? "Y" : "N";
        payload.CreditDate = new Date(payload.CreditDate).toSaveDate();
        payload.DateIn = new Date(payload.DateIn).toSaveDate();
        payload.DateChanged = new Date(payload.DateChanged)
          .toISOString()
          .replace("Z", "");
        payload.InvoiceDate = new Date(payload.InvoiceDate).toSaveDate();
        payload.SupplierCreditDetails = [];

        this.localDataSource._array
          .filter((item) => item.IsChecked)
          .map((item) => {
            const supplierCreditDetailsItem = {
              ActualStockConversion: item.ActualStockConversion,
              Comment: item.Comments,
              IsVariable: item.IsVariable,
              ItemCode: item.ItemCode,
              OriginalSupplierOutstandingReturnQty:
                item.SupplierOutstandingQuantity,
              ReturnedQty: -1 * item.CreditQty * item.ActualStockConversion,
              SourceGoodsInCode: item.GoodsInCode,
              SourceGoodsInLineNo: item.GoodsInLineNo,
              StandardStockConversion: item.StandardStockConversion,
              SupplierReturnedQty: -1 * item.CreditQty,
              SupplierCreditProductBatches: item.ChildDataSource._array
                .filter(
                  (batch) =>
                    batch.IsChecked && batch.SupplierBatchCreditQty !== 0
                )
                .map((batchItem) => {
                  return {
                    ActualStockConversion: item.ActualStockConversion,
                    BatchNo: batchItem.BatchNo,
                    Comment: "",
                    OriginalSupplierOutstandingReturnQty:
                      batchItem.OutstandingSupplierReturnQty,
                    SupplierReturnedQty: -1 * batchItem.SupplierBatchCreditQty,
                    UseByDate: batchItem.UseByDate,
                    ManufacturedDate: batchItem.ManufacturedDate,
                    BestBeforeDate: batchItem.BestBeforeDate,
                    ReturnedQty:
                      -1 *
                      batchItem.SupplierBatchCreditQty *
                      item.ActualStockConversion,
                  };
                }),
            };
            payload.SupplierCreditDetails.push(supplierCreditDetailsItem);
          });

        this.showLoading(true);
        await SupplierCreditService.saveSupplierCredit(payload)
          .then((res) => {
            if (res) this.showLoading(false);
            this.$notify(
              `Successfully created Supplier Credit ${res.data.Code}`,
              "success"
            );

            this.setIgnoreRouteChangeConfirmation();
            this.$router.push({
              path: `/supplier-invoiced`,
            });
          })
          .catch((err) => {
            this.showLoading(false);
            if (err) this.displayServerError(err);
          });
      }
    },
    addToValidationSum(message) {
      this.displayValidationSummary([
        {
          message: message,
        },
      ]);
    },

    /**
     * Update Footer
     */
    updateFooter() {
      /**
       * set line count
       */
      const lineCount = this.footerItems.find(
        (item) => item.dataField === "SupplierRequired"
      );
      if (lineCount) {
        lineCount.value = this.localDataSource._array.filter(
          (item) => item.IsChecked
        ).length;
      }

      /**
       * set Item Count
       */
      let totalQty = 0;
      this.localDataSource._array
        .filter((item) => item.IsChecked)
        .map((item) => (totalQty += item.CreditQty));
      const ItemCount = this.footerItems.find(
        (item) => item.dataField === "ItemCount"
      );
      if (ItemCount) {
        ItemCount.value = totalQty;
      }

      /**
       * set Total
       */
      let subTotal = 0;
      this.localDataSource._array
        .filter((item) => item.IsChecked)
        .map((item) => (subTotal += item.Amount));
      const FXLineTotal = this.footerItems.find(
        (item) => item.dataField === "FXLineTotal"
      );
      if (FXLineTotal) {
        FXLineTotal.value = subTotal.round2Decimal();
      }

      /**
       * set TaxFXTotal
       */
      let taxTotal = 0;
      this.localDataSource._array
        .filter((item) => item.IsChecked)
        .map((item) => (taxTotal += item.FXTaxLineTotal));
      const TaxFXTotal = this.footerItems.find(
        (item) => item.dataField === "TaxFXTotal"
      );
      if (TaxFXTotal) {
        TaxFXTotal.value = taxTotal.round2Decimal();
      }

      /**
       * set FXIncTaxLineTotal
       */
      let IncTaxLineTotal = 0;
      this.localDataSource._array
        .filter((item) => item.IsChecked)
        .map((item) => (IncTaxLineTotal += item.FXIncTaxLineTotal));
      const FXIncTaxLineTotal = this.footerItems.find(
        (item) => item.dataField === "FXIncTaxLineTotal"
      );
      if (FXIncTaxLineTotal) {
        FXIncTaxLineTotal.value = IncTaxLineTotal.round2Decimal();
      }

      /**
       * set Balance: Balance(FX), value of 0-Total(FX) in footer + Total(FX) in header
       */
      const Balance = this.footerItems.find(
        (item) => item.dataField === "Balance"
      );
      const TaxAdjustment = this.footerItems.find(
        (item) => item.dataField === "TaxAdjustment"
      ).value;
      if (Balance) {
        Balance.value = (
          this.model.Total -
          (TaxAdjustment + FXIncTaxLineTotal.value)
        ).round2Decimal();
      }
    },

    /**
     * Set Footer Items
     */
    setFooterItems() {
      this.footerItems = this.getFooterItems;
      this.showFooter = true;
    },
  },
};
</script>
<style scoped lang="scss">
.supplier-credit {
  .header-form {
    margin-bottom: 0 !important;
  }
}
</style>
